import CloseIconComponent from "~/features/icon/close.svg";
import { colors } from "~/theme";

CloseIconComponent.defaultProps = {
    color: colors.black,
};
export const CloseIcon = CloseIconComponent;
